// Translations for Black Star Threads
// Languages: English, French, Spanish, Portuguese, Dutch

export const translations = {
  en: {
    // Header & Navigation
    nav: {
      tournament: "Tournament",
      streetwear: "Streetwear",
      fan: "Fan",
      retro: "Retro",
      designers: "Designers",
      search: "Search jerseys...",
      myOrders: "My Orders",
      wishlist: "Wishlist",
      vendorDashboard: "Vendor Dashboard",
      adminDashboard: "Admin Dashboard",
      logout: "Logout",
      login: "Login",
      cart: "Cart"
    },
    // Announcement Bar
    announcement: {
      freeShipping: "FREE SHIPPING",
      onOrdersOver: "on orders over",
      useCode: "Use code",
      forDiscount: "for 10% off"
    },
    // Homepage
    home: {
      heroTitle: "BLACK STAR THREADS",
      heroSubtitle: "Premium Ghanaian jerseys for the global fan. Authentic quality, iconic designs.",
      shopNow: "Shop Now",
      exploreCollection: "Explore Collection",
      featured: "FEATURED",
      featuredJerseys: "Featured Jerseys",
      shopByCategory: "Shop by Category",
      viewAll: "View All",
      newArrivals: "NEW ARRIVALS",
      voteForNext: "Vote for the Next Jersey",
      voteDescription: "Help us decide which jersey design to produce next",
      votes: "votes",
      vote: "Vote",
      voted: "Voted",
      whyChooseUs: "Why Choose Black Star",
      authenticQuality: "Authentic Quality",
      authenticQualityDesc: "Premium materials and craftsmanship in every jersey",
      globalShipping: "Global Shipping",
      globalShippingDesc: "We deliver to fans worldwide with secure packaging",
      securePayment: "Secure Payment",
      securePaymentDesc: "Shop with confidence using our encrypted payment system",
      newsletter: "Join the Black Star Family",
      newsletterDesc: "Subscribe for exclusive drops, special offers, and Ghana football news",
      emailPlaceholder: "Enter your email",
      subscribe: "Subscribe"
    },
    // Products
    products: {
      allJerseys: "All Jerseys",
      showing: "Showing",
      of: "of",
      jerseys: "jerseys",
      sortBy: "Sort by",
      newest: "Newest",
      priceLowHigh: "Price: Low to High",
      priceHighLow: "Price: High to Low",
      popular: "Most Popular",
      filterBy: "Filter by",
      category: "Category",
      allCategories: "All Categories",
      priceRange: "Price Range",
      size: "Size",
      allSizes: "All Sizes",
      addToCart: "Add to Cart",
      outOfStock: "Out of Stock",
      limitedEdition: "Limited Edition",
      customizable: "Customizable"
    },
    // Product Detail
    productDetail: {
      selectSize: "Select Size",
      sizeGuide: "Size Guide",
      quantity: "Quantity",
      addToCart: "Add to Cart",
      addToWishlist: "Add to Wishlist",
      description: "Description",
      reviews: "Reviews",
      shipping: "Shipping",
      shippingInfo: "Free shipping on orders over $100. Standard delivery 5-7 business days.",
      customize: "Customize Your Jersey",
      customName: "Name on Jersey",
      customNumber: "Number",
      customizationFee: "Customization Fee",
      relatedProducts: "You May Also Like"
    },
    // Cart
    cart: {
      yourCart: "Your Cart",
      emptyCart: "Your cart is empty",
      continueShopping: "Continue Shopping",
      product: "Product",
      price: "Price",
      quantity: "Quantity",
      total: "Total",
      subtotal: "Subtotal",
      shipping: "Shipping",
      calculated: "Calculated at checkout",
      orderTotal: "Order Total",
      checkout: "Checkout",
      remove: "Remove",
      customization: "Customization"
    },
    // Checkout
    checkout: {
      checkout: "Checkout",
      shippingAddress: "Shipping Address",
      fullName: "Full Name",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2 (Optional)",
      city: "City",
      state: "State/Region",
      postalCode: "Postal Code",
      country: "Country",
      phone: "Phone Number",
      paymentMethod: "Payment Method",
      orderSummary: "Order Summary",
      placeOrder: "Place Order",
      promoCode: "Promo Code",
      apply: "Apply"
    },
    // Footer
    footer: {
      quickLinks: "Quick Links",
      about: "About Us",
      contact: "Contact",
      faq: "FAQ",
      returns: "Returns",
      customerService: "Customer Service",
      shippingInfo: "Shipping Info",
      sizeGuide: "Size Guide",
      trackOrder: "Track Order",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      sellWithUs: "Sell Your Jersey",
      followUs: "Follow Us",
      copyright: "All rights reserved."
    },
    // Common
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      close: "Close",
      confirm: "Confirm",
      back: "Back",
      next: "Next",
      previous: "Previous",
      submit: "Submit",
      currency: "Currency",
      language: "Language"
    },
    // Vendor
    vendor: {
      dashboard: "Vendor Dashboard",
      products: "Products",
      orders: "Orders",
      earnings: "Earnings",
      addProduct: "Add New Jersey",
      priceUSD: "Price (USD)",
      priceGHS: "Price (GHS)",
      enterBothPrices: "Enter prices in both currencies for international customers"
    },
    // Auth
    auth: {
      login: "Login",
      register: "Register",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      name: "Full Name",
      forgotPassword: "Forgot Password?",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      orContinueWith: "Or continue with",
      google: "Google",
      registerAsVendor: "Register as Vendor"
    }
  },
  
  fr: {
    // Header & Navigation
    nav: {
      tournament: "Tournoi",
      streetwear: "Streetwear",
      fan: "Fan",
      retro: "Rétro",
      designers: "Créateurs",
      search: "Rechercher des maillots...",
      myOrders: "Mes Commandes",
      wishlist: "Liste de Souhaits",
      vendorDashboard: "Tableau de Bord Vendeur",
      adminDashboard: "Tableau de Bord Admin",
      logout: "Déconnexion",
      login: "Connexion",
      cart: "Panier"
    },
    announcement: {
      freeShipping: "LIVRAISON GRATUITE",
      onOrdersOver: "pour les commandes de plus de",
      useCode: "Utilisez le code",
      forDiscount: "pour 10% de réduction"
    },
    home: {
      heroTitle: "BLACK STAR THREADS",
      heroSubtitle: "Maillots ghanéens premium pour les fans du monde entier. Qualité authentique, designs iconiques.",
      shopNow: "Acheter",
      exploreCollection: "Explorer la Collection",
      featured: "EN VEDETTE",
      featuredJerseys: "Maillots en Vedette",
      shopByCategory: "Acheter par Catégorie",
      viewAll: "Voir Tout",
      newArrivals: "NOUVEAUTÉS",
      voteForNext: "Votez pour le Prochain Maillot",
      voteDescription: "Aidez-nous à décider quel design de maillot produire",
      votes: "votes",
      vote: "Voter",
      voted: "Voté",
      whyChooseUs: "Pourquoi Choisir Black Star",
      authenticQuality: "Qualité Authentique",
      authenticQualityDesc: "Matériaux et fabrication premium dans chaque maillot",
      globalShipping: "Livraison Mondiale",
      globalShippingDesc: "Nous livrons aux fans du monde entier avec un emballage sécurisé",
      securePayment: "Paiement Sécurisé",
      securePaymentDesc: "Achetez en toute confiance avec notre système de paiement crypté",
      newsletter: "Rejoignez la Famille Black Star",
      newsletterDesc: "Abonnez-vous pour des offres exclusives et des nouvelles du football ghanéen",
      emailPlaceholder: "Entrez votre email",
      subscribe: "S'abonner"
    },
    products: {
      allJerseys: "Tous les Maillots",
      showing: "Affichage",
      of: "sur",
      jerseys: "maillots",
      sortBy: "Trier par",
      newest: "Plus Récent",
      priceLowHigh: "Prix: Croissant",
      priceHighLow: "Prix: Décroissant",
      popular: "Plus Populaire",
      filterBy: "Filtrer par",
      category: "Catégorie",
      allCategories: "Toutes Catégories",
      priceRange: "Gamme de Prix",
      size: "Taille",
      allSizes: "Toutes Tailles",
      addToCart: "Ajouter au Panier",
      outOfStock: "Rupture de Stock",
      limitedEdition: "Édition Limitée",
      customizable: "Personnalisable"
    },
    productDetail: {
      selectSize: "Sélectionner Taille",
      sizeGuide: "Guide des Tailles",
      quantity: "Quantité",
      addToCart: "Ajouter au Panier",
      addToWishlist: "Ajouter aux Favoris",
      description: "Description",
      reviews: "Avis",
      shipping: "Livraison",
      shippingInfo: "Livraison gratuite pour les commandes de plus de 100$. Livraison standard 5-7 jours ouvrables.",
      customize: "Personnalisez Votre Maillot",
      customName: "Nom sur le Maillot",
      customNumber: "Numéro",
      customizationFee: "Frais de Personnalisation",
      relatedProducts: "Vous Aimerez Aussi"
    },
    cart: {
      yourCart: "Votre Panier",
      emptyCart: "Votre panier est vide",
      continueShopping: "Continuer les Achats",
      product: "Produit",
      price: "Prix",
      quantity: "Quantité",
      total: "Total",
      subtotal: "Sous-total",
      shipping: "Livraison",
      calculated: "Calculé à la caisse",
      orderTotal: "Total de la Commande",
      checkout: "Passer à la Caisse",
      remove: "Supprimer",
      customization: "Personnalisation"
    },
    checkout: {
      checkout: "Paiement",
      shippingAddress: "Adresse de Livraison",
      fullName: "Nom Complet",
      addressLine1: "Adresse Ligne 1",
      addressLine2: "Adresse Ligne 2 (Optionnel)",
      city: "Ville",
      state: "État/Région",
      postalCode: "Code Postal",
      country: "Pays",
      phone: "Numéro de Téléphone",
      paymentMethod: "Mode de Paiement",
      orderSummary: "Résumé de la Commande",
      placeOrder: "Passer la Commande",
      promoCode: "Code Promo",
      apply: "Appliquer"
    },
    footer: {
      quickLinks: "Liens Rapides",
      about: "À Propos",
      contact: "Contact",
      faq: "FAQ",
      returns: "Retours",
      customerService: "Service Client",
      shippingInfo: "Info Livraison",
      sizeGuide: "Guide des Tailles",
      trackOrder: "Suivre Commande",
      legal: "Légal",
      privacy: "Politique de Confidentialité",
      terms: "Conditions d'Utilisation",
      sellWithUs: "Vendre vos Maillots",
      followUs: "Suivez-nous",
      copyright: "Tous droits réservés."
    },
    common: {
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      view: "Voir",
      close: "Fermer",
      confirm: "Confirmer",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      submit: "Soumettre",
      currency: "Devise",
      language: "Langue"
    },
    vendor: {
      dashboard: "Tableau de Bord Vendeur",
      products: "Produits",
      orders: "Commandes",
      earnings: "Revenus",
      addProduct: "Ajouter un Maillot",
      priceUSD: "Prix (USD)",
      priceGHS: "Prix (GHS)",
      enterBothPrices: "Entrez les prix dans les deux devises pour les clients internationaux"
    },
    auth: {
      login: "Connexion",
      register: "Inscription",
      email: "Email",
      password: "Mot de Passe",
      confirmPassword: "Confirmer le Mot de Passe",
      name: "Nom Complet",
      forgotPassword: "Mot de Passe Oublié?",
      noAccount: "Pas de compte?",
      hasAccount: "Déjà un compte?",
      orContinueWith: "Ou continuer avec",
      google: "Google",
      registerAsVendor: "S'inscrire comme Vendeur"
    }
  },
  
  es: {
    nav: {
      tournament: "Torneo",
      streetwear: "Streetwear",
      fan: "Fan",
      retro: "Retro",
      designers: "Diseñadores",
      search: "Buscar camisetas...",
      myOrders: "Mis Pedidos",
      wishlist: "Lista de Deseos",
      vendorDashboard: "Panel de Vendedor",
      adminDashboard: "Panel de Admin",
      logout: "Cerrar Sesión",
      login: "Iniciar Sesión",
      cart: "Carrito"
    },
    announcement: {
      freeShipping: "ENVÍO GRATIS",
      onOrdersOver: "en pedidos mayores de",
      useCode: "Usa el código",
      forDiscount: "para 10% de descuento"
    },
    home: {
      heroTitle: "BLACK STAR THREADS",
      heroSubtitle: "Camisetas ghanesas premium para fans de todo el mundo. Calidad auténtica, diseños icónicos.",
      shopNow: "Comprar",
      exploreCollection: "Explorar Colección",
      featured: "DESTACADO",
      featuredJerseys: "Camisetas Destacadas",
      shopByCategory: "Comprar por Categoría",
      viewAll: "Ver Todo",
      newArrivals: "NOVEDADES",
      voteForNext: "Vota por la Próxima Camiseta",
      voteDescription: "Ayúdanos a decidir qué diseño producir",
      votes: "votos",
      vote: "Votar",
      voted: "Votado",
      whyChooseUs: "Por Qué Elegir Black Star",
      authenticQuality: "Calidad Auténtica",
      authenticQualityDesc: "Materiales y artesanía premium en cada camiseta",
      globalShipping: "Envío Mundial",
      globalShippingDesc: "Entregamos a fans de todo el mundo con empaque seguro",
      securePayment: "Pago Seguro",
      securePaymentDesc: "Compra con confianza usando nuestro sistema de pago encriptado",
      newsletter: "Únete a la Familia Black Star",
      newsletterDesc: "Suscríbete para ofertas exclusivas y noticias del fútbol ghanés",
      emailPlaceholder: "Ingresa tu email",
      subscribe: "Suscribirse"
    },
    products: {
      allJerseys: "Todas las Camisetas",
      showing: "Mostrando",
      of: "de",
      jerseys: "camisetas",
      sortBy: "Ordenar por",
      newest: "Más Nuevo",
      priceLowHigh: "Precio: Menor a Mayor",
      priceHighLow: "Precio: Mayor a Menor",
      popular: "Más Popular",
      filterBy: "Filtrar por",
      category: "Categoría",
      allCategories: "Todas las Categorías",
      priceRange: "Rango de Precio",
      size: "Talla",
      allSizes: "Todas las Tallas",
      addToCart: "Añadir al Carrito",
      outOfStock: "Agotado",
      limitedEdition: "Edición Limitada",
      customizable: "Personalizable"
    },
    productDetail: {
      selectSize: "Seleccionar Talla",
      sizeGuide: "Guía de Tallas",
      quantity: "Cantidad",
      addToCart: "Añadir al Carrito",
      addToWishlist: "Añadir a Favoritos",
      description: "Descripción",
      reviews: "Reseñas",
      shipping: "Envío",
      shippingInfo: "Envío gratis en pedidos mayores de $100. Entrega estándar 5-7 días hábiles.",
      customize: "Personaliza Tu Camiseta",
      customName: "Nombre en la Camiseta",
      customNumber: "Número",
      customizationFee: "Cargo por Personalización",
      relatedProducts: "También Te Puede Gustar"
    },
    cart: {
      yourCart: "Tu Carrito",
      emptyCart: "Tu carrito está vacío",
      continueShopping: "Continuar Comprando",
      product: "Producto",
      price: "Precio",
      quantity: "Cantidad",
      total: "Total",
      subtotal: "Subtotal",
      shipping: "Envío",
      calculated: "Calculado al pagar",
      orderTotal: "Total del Pedido",
      checkout: "Pagar",
      remove: "Eliminar",
      customization: "Personalización"
    },
    checkout: {
      checkout: "Pago",
      shippingAddress: "Dirección de Envío",
      fullName: "Nombre Completo",
      addressLine1: "Dirección Línea 1",
      addressLine2: "Dirección Línea 2 (Opcional)",
      city: "Ciudad",
      state: "Estado/Región",
      postalCode: "Código Postal",
      country: "País",
      phone: "Número de Teléfono",
      paymentMethod: "Método de Pago",
      orderSummary: "Resumen del Pedido",
      placeOrder: "Realizar Pedido",
      promoCode: "Código Promocional",
      apply: "Aplicar"
    },
    footer: {
      quickLinks: "Enlaces Rápidos",
      about: "Sobre Nosotros",
      contact: "Contacto",
      faq: "FAQ",
      returns: "Devoluciones",
      customerService: "Servicio al Cliente",
      shippingInfo: "Info de Envío",
      sizeGuide: "Guía de Tallas",
      trackOrder: "Rastrear Pedido",
      legal: "Legal",
      privacy: "Política de Privacidad",
      terms: "Términos de Servicio",
      sellWithUs: "Vende tus Camisetas",
      followUs: "Síguenos",
      copyright: "Todos los derechos reservados."
    },
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      view: "Ver",
      close: "Cerrar",
      confirm: "Confirmar",
      back: "Atrás",
      next: "Siguiente",
      previous: "Anterior",
      submit: "Enviar",
      currency: "Moneda",
      language: "Idioma"
    },
    vendor: {
      dashboard: "Panel de Vendedor",
      products: "Productos",
      orders: "Pedidos",
      earnings: "Ganancias",
      addProduct: "Añadir Camiseta",
      priceUSD: "Precio (USD)",
      priceGHS: "Precio (GHS)",
      enterBothPrices: "Ingresa precios en ambas monedas para clientes internacionales"
    },
    auth: {
      login: "Iniciar Sesión",
      register: "Registrarse",
      email: "Email",
      password: "Contraseña",
      confirmPassword: "Confirmar Contraseña",
      name: "Nombre Completo",
      forgotPassword: "¿Olvidaste tu Contraseña?",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      orContinueWith: "O continuar con",
      google: "Google",
      registerAsVendor: "Registrarse como Vendedor"
    }
  },
  
  pt: {
    nav: {
      tournament: "Torneio",
      streetwear: "Streetwear",
      fan: "Fã",
      retro: "Retrô",
      designers: "Designers",
      search: "Buscar camisas...",
      myOrders: "Meus Pedidos",
      wishlist: "Lista de Desejos",
      vendorDashboard: "Painel do Vendedor",
      adminDashboard: "Painel Admin",
      logout: "Sair",
      login: "Entrar",
      cart: "Carrinho"
    },
    announcement: {
      freeShipping: "FRETE GRÁTIS",
      onOrdersOver: "em pedidos acima de",
      useCode: "Use o código",
      forDiscount: "para 10% de desconto"
    },
    home: {
      heroTitle: "BLACK STAR THREADS",
      heroSubtitle: "Camisas ganesas premium para fãs de todo o mundo. Qualidade autêntica, designs icônicos.",
      shopNow: "Comprar",
      exploreCollection: "Explorar Coleção",
      featured: "DESTAQUE",
      featuredJerseys: "Camisas em Destaque",
      shopByCategory: "Comprar por Categoria",
      viewAll: "Ver Tudo",
      newArrivals: "NOVIDADES",
      voteForNext: "Vote na Próxima Camisa",
      voteDescription: "Ajude-nos a decidir qual design produzir",
      votes: "votos",
      vote: "Votar",
      voted: "Votado",
      whyChooseUs: "Por Que Escolher Black Star",
      authenticQuality: "Qualidade Autêntica",
      authenticQualityDesc: "Materiais e artesanato premium em cada camisa",
      globalShipping: "Envio Mundial",
      globalShippingDesc: "Entregamos para fãs do mundo todo com embalagem segura",
      securePayment: "Pagamento Seguro",
      securePaymentDesc: "Compre com confiança usando nosso sistema de pagamento criptografado",
      newsletter: "Junte-se à Família Black Star",
      newsletterDesc: "Inscreva-se para ofertas exclusivas e notícias do futebol ganês",
      emailPlaceholder: "Digite seu email",
      subscribe: "Inscrever-se"
    },
    products: {
      allJerseys: "Todas as Camisas",
      showing: "Mostrando",
      of: "de",
      jerseys: "camisas",
      sortBy: "Ordenar por",
      newest: "Mais Novo",
      priceLowHigh: "Preço: Menor para Maior",
      priceHighLow: "Preço: Maior para Menor",
      popular: "Mais Popular",
      filterBy: "Filtrar por",
      category: "Categoria",
      allCategories: "Todas as Categorias",
      priceRange: "Faixa de Preço",
      size: "Tamanho",
      allSizes: "Todos os Tamanhos",
      addToCart: "Adicionar ao Carrinho",
      outOfStock: "Esgotado",
      limitedEdition: "Edição Limitada",
      customizable: "Personalizável"
    },
    productDetail: {
      selectSize: "Selecionar Tamanho",
      sizeGuide: "Guia de Tamanhos",
      quantity: "Quantidade",
      addToCart: "Adicionar ao Carrinho",
      addToWishlist: "Adicionar aos Favoritos",
      description: "Descrição",
      reviews: "Avaliações",
      shipping: "Envio",
      shippingInfo: "Frete grátis em pedidos acima de $100. Entrega padrão 5-7 dias úteis.",
      customize: "Personalize Sua Camisa",
      customName: "Nome na Camisa",
      customNumber: "Número",
      customizationFee: "Taxa de Personalização",
      relatedProducts: "Você Também Pode Gostar"
    },
    cart: {
      yourCart: "Seu Carrinho",
      emptyCart: "Seu carrinho está vazio",
      continueShopping: "Continuar Comprando",
      product: "Produto",
      price: "Preço",
      quantity: "Quantidade",
      total: "Total",
      subtotal: "Subtotal",
      shipping: "Envio",
      calculated: "Calculado no checkout",
      orderTotal: "Total do Pedido",
      checkout: "Finalizar",
      remove: "Remover",
      customization: "Personalização"
    },
    checkout: {
      checkout: "Checkout",
      shippingAddress: "Endereço de Entrega",
      fullName: "Nome Completo",
      addressLine1: "Endereço Linha 1",
      addressLine2: "Endereço Linha 2 (Opcional)",
      city: "Cidade",
      state: "Estado/Região",
      postalCode: "CEP",
      country: "País",
      phone: "Telefone",
      paymentMethod: "Método de Pagamento",
      orderSummary: "Resumo do Pedido",
      placeOrder: "Fazer Pedido",
      promoCode: "Código Promocional",
      apply: "Aplicar"
    },
    footer: {
      quickLinks: "Links Rápidos",
      about: "Sobre Nós",
      contact: "Contato",
      faq: "FAQ",
      returns: "Devoluções",
      customerService: "Atendimento ao Cliente",
      shippingInfo: "Info de Envio",
      sizeGuide: "Guia de Tamanhos",
      trackOrder: "Rastrear Pedido",
      legal: "Legal",
      privacy: "Política de Privacidade",
      terms: "Termos de Serviço",
      sellWithUs: "Venda suas Camisas",
      followUs: "Siga-nos",
      copyright: "Todos os direitos reservados."
    },
    common: {
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      save: "Salvar",
      cancel: "Cancelar",
      delete: "Excluir",
      edit: "Editar",
      view: "Ver",
      close: "Fechar",
      confirm: "Confirmar",
      back: "Voltar",
      next: "Próximo",
      previous: "Anterior",
      submit: "Enviar",
      currency: "Moeda",
      language: "Idioma"
    },
    vendor: {
      dashboard: "Painel do Vendedor",
      products: "Produtos",
      orders: "Pedidos",
      earnings: "Ganhos",
      addProduct: "Adicionar Camisa",
      priceUSD: "Preço (USD)",
      priceGHS: "Preço (GHS)",
      enterBothPrices: "Digite preços em ambas moedas para clientes internacionais"
    },
    auth: {
      login: "Entrar",
      register: "Registrar",
      email: "Email",
      password: "Senha",
      confirmPassword: "Confirmar Senha",
      name: "Nome Completo",
      forgotPassword: "Esqueceu a Senha?",
      noAccount: "Não tem conta?",
      hasAccount: "Já tem conta?",
      orContinueWith: "Ou continuar com",
      google: "Google",
      registerAsVendor: "Registrar como Vendedor"
    }
  },
  
  nl: {
    nav: {
      tournament: "Toernooi",
      streetwear: "Streetwear",
      fan: "Fan",
      retro: "Retro",
      designers: "Ontwerpers",
      search: "Zoek shirts...",
      myOrders: "Mijn Bestellingen",
      wishlist: "Verlanglijst",
      vendorDashboard: "Verkoper Dashboard",
      adminDashboard: "Admin Dashboard",
      logout: "Uitloggen",
      login: "Inloggen",
      cart: "Winkelwagen"
    },
    announcement: {
      freeShipping: "GRATIS VERZENDING",
      onOrdersOver: "bij bestellingen boven",
      useCode: "Gebruik code",
      forDiscount: "voor 10% korting"
    },
    home: {
      heroTitle: "BLACK STAR THREADS",
      heroSubtitle: "Premium Ghanese shirts voor fans wereldwijd. Authentieke kwaliteit, iconische ontwerpen.",
      shopNow: "Shop Nu",
      exploreCollection: "Bekijk Collectie",
      featured: "UITGELICHT",
      featuredJerseys: "Uitgelichte Shirts",
      shopByCategory: "Shop per Categorie",
      viewAll: "Alles Bekijken",
      newArrivals: "NIEUW BINNEN",
      voteForNext: "Stem voor het Volgende Shirt",
      voteDescription: "Help ons beslissen welk ontwerp we produceren",
      votes: "stemmen",
      vote: "Stem",
      voted: "Gestemd",
      whyChooseUs: "Waarom Black Star Kiezen",
      authenticQuality: "Authentieke Kwaliteit",
      authenticQualityDesc: "Premium materialen en vakmanschap in elk shirt",
      globalShipping: "Wereldwijde Verzending",
      globalShippingDesc: "We leveren aan fans wereldwijd met veilige verpakking",
      securePayment: "Veilig Betalen",
      securePaymentDesc: "Shop met vertrouwen met ons versleutelde betalingssysteem",
      newsletter: "Word Lid van de Black Star Familie",
      newsletterDesc: "Abonneer voor exclusieve aanbiedingen en Ghanees voetbalnieuws",
      emailPlaceholder: "Voer je email in",
      subscribe: "Abonneren"
    },
    products: {
      allJerseys: "Alle Shirts",
      showing: "Tonen",
      of: "van",
      jerseys: "shirts",
      sortBy: "Sorteer op",
      newest: "Nieuwste",
      priceLowHigh: "Prijs: Laag naar Hoog",
      priceHighLow: "Prijs: Hoog naar Laag",
      popular: "Meest Populair",
      filterBy: "Filter op",
      category: "Categorie",
      allCategories: "Alle Categorieën",
      priceRange: "Prijsklasse",
      size: "Maat",
      allSizes: "Alle Maten",
      addToCart: "In Winkelwagen",
      outOfStock: "Uitverkocht",
      limitedEdition: "Beperkte Editie",
      customizable: "Aanpasbaar"
    },
    productDetail: {
      selectSize: "Selecteer Maat",
      sizeGuide: "Maatgids",
      quantity: "Aantal",
      addToCart: "In Winkelwagen",
      addToWishlist: "Toevoegen aan Verlanglijst",
      description: "Beschrijving",
      reviews: "Beoordelingen",
      shipping: "Verzending",
      shippingInfo: "Gratis verzending bij bestellingen boven $100. Standaard levering 5-7 werkdagen.",
      customize: "Personaliseer Je Shirt",
      customName: "Naam op Shirt",
      customNumber: "Nummer",
      customizationFee: "Personalisatiekosten",
      relatedProducts: "Misschien Vind Je Dit Ook Leuk"
    },
    cart: {
      yourCart: "Je Winkelwagen",
      emptyCart: "Je winkelwagen is leeg",
      continueShopping: "Verder Winkelen",
      product: "Product",
      price: "Prijs",
      quantity: "Aantal",
      total: "Totaal",
      subtotal: "Subtotaal",
      shipping: "Verzending",
      calculated: "Berekend bij afrekenen",
      orderTotal: "Totaal Bestelling",
      checkout: "Afrekenen",
      remove: "Verwijderen",
      customization: "Personalisatie"
    },
    checkout: {
      checkout: "Afrekenen",
      shippingAddress: "Verzendadres",
      fullName: "Volledige Naam",
      addressLine1: "Adresregel 1",
      addressLine2: "Adresregel 2 (Optioneel)",
      city: "Stad",
      state: "Provincie/Regio",
      postalCode: "Postcode",
      country: "Land",
      phone: "Telefoonnummer",
      paymentMethod: "Betaalmethode",
      orderSummary: "Bestellingsoverzicht",
      placeOrder: "Bestelling Plaatsen",
      promoCode: "Promotiecode",
      apply: "Toepassen"
    },
    footer: {
      quickLinks: "Snelle Links",
      about: "Over Ons",
      contact: "Contact",
      faq: "FAQ",
      returns: "Retourneren",
      customerService: "Klantenservice",
      shippingInfo: "Verzendinfo",
      sizeGuide: "Maatgids",
      trackOrder: "Bestelling Volgen",
      legal: "Juridisch",
      privacy: "Privacybeleid",
      terms: "Algemene Voorwaarden",
      sellWithUs: "Verkoop Je Shirts",
      followUs: "Volg Ons",
      copyright: "Alle rechten voorbehouden."
    },
    common: {
      loading: "Laden...",
      error: "Fout",
      success: "Succes",
      save: "Opslaan",
      cancel: "Annuleren",
      delete: "Verwijderen",
      edit: "Bewerken",
      view: "Bekijken",
      close: "Sluiten",
      confirm: "Bevestigen",
      back: "Terug",
      next: "Volgende",
      previous: "Vorige",
      submit: "Versturen",
      currency: "Valuta",
      language: "Taal"
    },
    vendor: {
      dashboard: "Verkoper Dashboard",
      products: "Producten",
      orders: "Bestellingen",
      earnings: "Inkomsten",
      addProduct: "Shirt Toevoegen",
      priceUSD: "Prijs (USD)",
      priceGHS: "Prijs (GHS)",
      enterBothPrices: "Voer prijzen in beide valuta's in voor internationale klanten"
    },
    auth: {
      login: "Inloggen",
      register: "Registreren",
      email: "Email",
      password: "Wachtwoord",
      confirmPassword: "Bevestig Wachtwoord",
      name: "Volledige Naam",
      forgotPassword: "Wachtwoord Vergeten?",
      noAccount: "Geen account?",
      hasAccount: "Al een account?",
      orContinueWith: "Of ga verder met",
      google: "Google",
      registerAsVendor: "Registreer als Verkoper"
    }
  }
};

// Language metadata with flags (using emoji flags)
export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧', nativeName: 'English' },
  { code: 'fr', name: 'French', flag: '🇫🇷', nativeName: 'Français' },
  { code: 'es', name: 'Spanish', flag: '🇪🇸', nativeName: 'Español' },
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹', nativeName: 'Português' },
  { code: 'nl', name: 'Dutch', flag: '🇳🇱', nativeName: 'Nederlands' }
];

// Currency configuration
export const currencies = {
  USD: { symbol: '$', code: 'USD', name: 'US Dollar' },
  GHS: { symbol: 'GH₵', code: 'GHS', name: 'Ghana Cedi' }
};

// Exchange rate (approximate - should be updated or fetched from API)
export const GHS_TO_USD_RATE = 0.065; // 1 GHS = ~0.065 USD
export const USD_TO_GHS_RATE = 15.38; // 1 USD = ~15.38 GHS
